import React from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { NotFoundRoute } from './NotFoundRoute';
import { getPlayerViewId } from '../Player/utils/utils';
import { getPlayerThunk } from '../../store/player/thunks';
import { connect, ConnectedProps } from 'react-redux';
import { SuspenseWrapper } from './SuspenseWrapper';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';
import { PlayerContextProvider } from '../Player/PlayerContext';
import { useFetchPlayBackHistoryForItems } from '../../service/areena-api/hooks/useFetchPlayBackHistoryForItems';

const PlayerRoute: React.FC<Props> = ({ getPlayer }) => {
  const { mode } = useAppFeaturesContext();

  const { itemId: unvalidatedItemId } = useParams();
  const [searchParams] = useSearchParams();
  const unvalidatedProgramId = searchParams.get('programId');
  const unvalidatedPublicationId = searchParams.get('publicationId');

  const itemId = unvalidatedItemId
    ? unvalidatedItemId.match(
        /(1-\d+|yle-tv1|yle-tv2|yle-teema-fem|yle-areena|yle-radio-1|ylex|yle-radio-suomi-[a-z]+|yle-puhe|radio-vega-[a-z]+|yle-x3m|yle-klassinen|yle-sami-radio|areena-audio-live)/
      )?.[0]
    : null;

  const { data: playBackHistoryItems, isLoading } =
    useFetchPlayBackHistoryForItems(itemId ? [itemId] : undefined);

  if (!itemId) {
    return <NotFoundRoute />;
  }

  const programId = unvalidatedProgramId?.match(/(1-\d+)/)?.[0];
  const publicationId = unvalidatedPublicationId?.match(/(4-\d+)/)?.[0];

  const viewId = getPlayerViewId(itemId, publicationId);

  const playerPromise = getPlayer(
    mode,
    viewId,
    itemId,
    programId,
    publicationId
  );

  return (
    <SuspenseWrapper promiseToWait={playerPromise} isLoading={isLoading}>
      <AuthRequired>
        <PlayerContextProvider>
          <PlayerComponent
            playerViewId={viewId}
            itemId={itemId}
            durationWatched={playBackHistoryItems?.[itemId]}
          />
        </PlayerContextProvider>
      </AuthRequired>
    </SuspenseWrapper>
  );
};

const PlayerComponent = React.lazy(() => import('../Player/PlayerContainer'));
const AuthRequired = React.lazy(() => import('./redirects/AuthRedirect'));

const mapDispatchToProps = {
  getPlayer: getPlayerThunk,
};

const connector = connect(null, mapDispatchToProps);

type Props = ConnectedProps<typeof connector>;

export default connector(PlayerRoute);
